import { checkPermission } from '@/router/guards.ts'

const PaymentMethodModule = () => import('./PaymentMethodModule.vue')
const PaymentMethodIndex = () => import('./views/PaymentMethodIndex.vue')

export const paymentMethodRoute = {
  path: '/payment-methods',
  name: 'payment-method',
  component: PaymentMethodModule,
  meta: {
    title: 'Payment Methods',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'payment-methods-index',
      component: PaymentMethodIndex,
      meta: {
        permission: 'payment_method.view',
      },
      beforeEnter: checkPermission('payment_method.view'),
    },
  ],
}
